import { Pagination } from "src/app/core/data/model";
import { BlocState } from "../base-bloc";


export abstract class TreeDropdownState extends BlocState {}

export class DropdownInitialState extends TreeDropdownState {}

// Loading
export class TreeDropdownLoadingState extends TreeDropdownState {}

// Ready
export class TreeDropdownReadyState<T> extends TreeDropdownState {
  constructor(public list: T[] , public pagination : Pagination) {
    super();
  }
}

export class TreeDropdownSearchReadyState<T> extends TreeDropdownState {
  constructor(public list: T[] , public pagination : Pagination) {
    super();
  }
}
